module.exports = __webpack_public_path__ + "img/hc_pro_seven_4.04a23d71.jpg";